var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 1.30099C9.58991 4.397 7.41493 7.41464 5.12231 10.3539C4.10333 9.47215 3.0648 8.59041 2.04582 7.7085C0.909309 6.72874 -0.756199 8.37469 0.380173 9.37414C1.73227 10.5499 3.08432 11.706 4.45594 12.8817C4.88703 13.254 5.71002 13.4108 6.12159 12.8817C8.76699 9.51131 11.3143 6.04299 13.7049 2.49629C14.5672 1.2422 12.5292 0.0665703 11.6867 1.30099H11.6867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.715425fe3b3c2532390a38d0a9037d5a.svg";
export { ForwardRef as ReactComponent };